import { Body, Box } from '@hover/blueprint';
import React from 'react';

import renderingAfterPicture from 'src/assets/img/rendering/after.png';
import renderingBeforePicture from 'src/assets/img/rendering/before.png';
import { RenderingCTATrackingIDs } from 'src/modules/designStudio/components/DesignMenu/RenderingRequest/types';
import { Button, Image, Link } from 'src/shared/components';
import type { ButtonPressed, LinkPressed } from 'src/shared/telemetry';

const LEFT_SIDE_ROUNDED = '4px 0px 0px 4px';
const RIGHT_SIDE_ROUNDED = '0px 4px 4px 0px';

const TextOverlayImage = ({
  src,
  text,
  right,
}: {
  src: string;
  text: string;
  right?: boolean;
}) => (
  <Box height="100%" position="relative" width={600}>
    <Body color="white" isSemiBold margin={200} position="absolute" size={200}>
      {text}
    </Body>
    <Image
      alt={`rendering ${text} picture`}
      borderRadius={right ? RIGHT_SIDE_ROUNDED : LEFT_SIDE_ROUNDED}
      height="100%"
      src={src}
      width="100%"
    />
  </Box>
);

const RenderingPopoverContent = ({
  after,
  before,
  loading,
  handleRenderingRequestClick,
  headingText,
  detailsText,
  ctaButtonText,
  learnMoreText,
  trackingProperties,
}: {
  after: string;
  before: string;
  loading: boolean;
  handleRenderingRequestClick: () => void;
  headingText: string;
  detailsText: string;
  ctaButtonText: string;
  learnMoreText: string;
  trackingProperties: Partial<ButtonPressed> | Partial<LinkPressed>;
}) => (
  <Box
    alignItems="center"
    flexDirection="column"
    height="390px"
    justifyContent="space-around"
    paddingX={500}
    width="302px"
  >
    <Body align="center" color="neutral.text" fontWeight={700} size={400}>
      {headingText}
    </Body>
    <Box display="flex" height="110px">
      <TextOverlayImage src={renderingBeforePicture} text={before} />
      <Box height="100%" width={25} />
      <TextOverlayImage right src={renderingAfterPicture} text={after} />
    </Box>
    <Body align="center" fontWeight="regular" size={400}>
      {detailsText}
    </Body>
    <Button
      isLoading={loading}
      label="request rendering"
      onClick={handleRenderingRequestClick}
      optionalTrackingProperties={{
        ...trackingProperties,
        track_id: RenderingCTATrackingIDs.RENDERING_CTA,
      }}
      size="large"
      testId="rendering-cta-button"
    >
      {ctaButtonText}
    </Button>
    <Link
      fontWeight={600}
      isExternal
      marginTop={400}
      optionalTrackingProperties={{
        ...trackingProperties,
        track_id: RenderingCTATrackingIDs.LEARN_MORE,
      }}
      size={400}
      target="_blank"
      to="/renderings"
    >
      {learnMoreText}
    </Link>
  </Box>
);
export { RenderingPopoverContent };
